import { Button } from "@/components/ui/button";
import { Dumbbell, Utensils, BarChart3, RotateCcw } from "lucide-react";

export default function StepWelcome({ user, onNext, onResume, resumeStep, onRestart }) {
  const firstName = user?.full_name?.split(" ")[0] ?? "there";
  const canResume = !!onResume && typeof resumeStep === "number" && resumeStep > 0;
  return (
    <div className="text-center space-y-6">
      <div>
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">
          Welcome to TA Fitness
        </p>
        <h1 className="text-3xl font-heading font-bold text-foreground mt-2">
          Hey {firstName} 👋
        </h1>
        <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
          Let&apos;s build your personalized training and nutrition plan in about{" "}
          <span className="font-semibold text-foreground">3 minutes</span>.
        </p>
      </div>

      {canResume && (
        <div
          className="rounded-xl border border-primary/30 bg-primary/5 px-4 py-3 text-left"
          data-testid="onboarding-resume-banner"
        >
          <div className="flex items-center gap-2 mb-1">
            <RotateCcw className="w-3.5 h-3.5 text-primary" />
            <span className="text-xs font-semibold uppercase tracking-wider text-primary">
              Pick up where you left off
            </span>
          </div>
          <p className="text-xs text-muted-foreground mb-2">
            You stopped on step {resumeStep} of 7. Your answers are saved.
          </p>
          <div className="flex gap-2">
            <Button
              variant="default"
              className="flex-1 h-9 text-sm"
              onClick={onResume}
              data-testid="onboarding-resume"
            >
              Resume
            </Button>
            <Button
              variant="ghost"
              className="flex-1 h-9 text-sm"
              onClick={onRestart}
              data-testid="onboarding-restart"
            >
              Start over
            </Button>
          </div>
        </div>
      )}

      <div className="space-y-2.5 text-left">
        {[
          { icon: Dumbbell, label: "Tailored workout & training intensity" },
          { icon: Utensils, label: "Personal macro & calorie targets" },
          { icon: BarChart3, label: "Weekly check-in cadence built for you" },
        ].map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-3 bg-muted/40 rounded-xl px-4 py-3">
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-primary" />
            </div>
            <span className="text-sm font-medium">{label}</span>
          </div>
        ))}
      </div>

      <Button
        className="w-full h-11 text-base font-semibold"
        onClick={onNext}
        data-testid="onboarding-get-started"
      >
        {canResume ? "Start a new plan" : "Get Started"}
      </Button>
    </div>
  );
}
